import { render, staticRenderFns } from "./ProductItemseven.vue?vue&type=template&id=0a805f39&scoped=true"
import script from "./ProductItemseven.vue?vue&type=script&lang=js"
export * from "./ProductItemseven.vue?vue&type=script&lang=js"
import style0 from "./ProductItemseven.vue?vue&type=style&index=0&id=0a805f39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a805f39",
  null
  
)

export default component.exports